import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Header } from "../components/Header";
import { ExerciseCard } from "../components/ExerciseCard";
import { ChevronLeft } from "lucide-react";
import { motion } from "framer-motion";

const API = `/api`;

export default function ExercisesPage() {
  const [exercises, setExercises] = useState([]);
  useEffect(() => { axios.get(`${API}/exercises`).then(r => setExercises(r.data)); }, []);

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Link to="/dashboard" className="text-sm text-[#6A7771] hover:text-[#6B8576] flex items-center gap-1 mb-6 transition-colors duration-200"><ChevronLeft className="w-4 h-4" strokeWidth={1.5} /> Retour</Link>
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <h1 className="text-3xl font-semibold text-[#2C3531] mb-2" style={{ fontFamily: 'Outfit' }}>Exercices pratiques</h1>
          <p className="text-[#6A7771] mb-8">14 exercices pour explorer, comprendre et avancer à votre rythme</p>
        </motion.div>
        <motion.div
          initial="hidden" animate="show"
          variants={{ hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.05 } } }}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4"
        >
          {exercises.map(ex => (
            <motion.div key={ex.id} variants={{ hidden: { opacity: 0, y: 12 }, show: { opacity: 1, y: 0 } }}>
              <ExerciseCard exercise={ex} />
            </motion.div>
          ))}
        </motion.div>
      </main>
    </div>
  );
}
